const Home = ({ metaData }) => {
    return (
        <div>HOME PAGE</div>
    );
};

export default Home;